export enum CalendarMonthTagType {
    Events = 'events',
    Standard = 'standard',
    Offers = 'offers',
    Leads = 'leads',
    Reservations = 'reservations',
}
